export enum PartnerOrder {
  CREATED_AT = 'createdAt',
  TOTAL_SALES = 'totalSales',
  ORDER_COUNT = 'orderCount',
  GRADE = 'grade',
}
